import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dashboard-filter"
//
// Client-side filtering of the admin dashboard product cards. Clicking a
// product button in the sidebar hides cards that don't match; clicking
// "Všetky" reveals them again. No server roundtrip — the dataset stays
// frozen at the original page load until the operator hits refresh.
export default class extends Controller {
  static targets = ["card", "button", "clear"];

  connect() {
    this.toggleClear(false);
  }

  select(event) {
    const productId = event.currentTarget.dataset.productId;

    this.cardTargets.forEach((card) => {
      card.classList.toggle("hidden", card.dataset.productId !== productId);
    });

    this.buttonTargets.forEach((button) => {
      const isSelected = button.dataset.productId === productId;
      button.classList.toggle("font-semibold", isSelected);
      button.style.backgroundColor = isSelected
        ? button.dataset.selectedBackground
        : "";
    });

    this.toggleClear(true);
  }

  clear() {
    this.cardTargets.forEach((card) => card.classList.remove("hidden"));
    this.buttonTargets.forEach((button) => {
      button.classList.remove("font-semibold");
      button.style.backgroundColor = "";
    });
    this.toggleClear(false);
  }

  toggleClear(visible) {
    if (!this.hasClearTarget) return;
    this.clearTarget.classList.toggle("hidden", !visible);
  }
}
